function saveOpenedDetailsElements() {
  const openedDetailsElements = document.querySelectorAll('details[open]');
  const openedDetailsHandles = Array.from(openedDetailsElements).map((details) => details.id);
  const activeMenuItems = document.querySelectorAll('a.menu-drawer__menu-item--active');
  const activeMenuHandles = Array.from(activeMenuItems).map((item) => item.id);
  localStorage.setItem('openedDetailsElements', JSON.stringify(openedDetailsHandles));
  localStorage.setItem('activeMenuItems', JSON.stringify(activeMenuHandles));
}

function restoreOpenedDetailsElements() {
  const savedOpenedDetailsElements = JSON.parse(localStorage.getItem('openedDetailsElements') || '[]');
  const activeMenuHandles = JSON.parse(localStorage.getItem('activeMenuItems') || '[]');
  savedOpenedDetailsElements.forEach((handle) => {
    const detailsElement = document.getElementById(handle);
    if (detailsElement) {
      detailsElement.setAttribute('open', 'open');
      detailsElement.classList.add('menu-opening');
      const summaryElement = detailsElement.querySelector('summary');
      if (summaryElement) {
        summaryElement.classList.add('menu-drawer__menu-item--active');
      }
    }
  });
  activeMenuHandles.forEach((handle) => {
    const activeMenuItem = document.getElementById(handle);
    if (activeMenuItem) {
      activeMenuItem.classList.add('menu-drawer__menu-item--active');
    }
  });
}

function clearLocalStorageOnNavigation() {
  if (!window.location.pathname.includes('/products/')) {
    localStorage.removeItem('openedDetailsElements');
    localStorage.removeItem('activeMenuItems');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const currentPath = window.location.pathname;

  if (currentPath.includes('/collections/')) {
    saveOpenedDetailsElements();
  }

  if (currentPath.includes('/products/')) {
    restoreOpenedDetailsElements();
    window.addEventListener('beforeunload', clearLocalStorageOnNavigation);
    window.addEventListener('popstate', clearLocalStorageOnNavigation);
    window.addEventListener('click', function (event) {
      if (event.target.tagName === 'A') {
        clearLocalStorageOnNavigation();
      }
    });
  }
});
